export default {

  activeName: {activeName: null}, //Tab选中

  NavID: null, // 被选中的菜单项

  IsLb: null,

  Treeid: null, //树ID
  checkNode: [],
  layname: '',
  
  minedata: {
    name: '',
    url: '',
    bool: '',
    route: ''
  },
  searchtype: null, //一张图搜索类型

  Marktype: null,  //标注类型

  MeasureNum: null,  //测算结果

  PreviousYears: null,  //往届回顾

  meetingid: null,  //会议id

  processid: null, //大会议程

  kyltMid: null, //矿业论坛会议

  dwid: null, //矿业论坛会议

  kyqtjid: null //矿业权推介id
}



// WEBPACK FOOTER //
// ./src/store/state.js